import { BREAKPOINTS, NodeProps, Props } from '../metadata';

import { isUndefined } from '.';

function getBreakpointProps(props: NodeProps, breakpoint: string): Props {
  if (isUndefined(props)) {
    return {};
  }

  const breakpoints = props[BREAKPOINTS];
  if (isUndefined(breakpoints)) {
    return {};
  }

  const foundBreakpoint = breakpoints[breakpoint];
  return foundBreakpoint ? { ...foundBreakpoint } : {};
}

export default getBreakpointProps;
